import React from 'react';
import mixpanel from 'mixpanel-browser';

import { InfoTooltip } from './Tooltip';

import { TOASTER_HEADER, WIN_GIFT_CARD, COMPLETE_SURVEY } from '../../constants/Surveys/index';

import './Toaster.css';
export default function ToasterSurvey({ userId }) {
  return (
    <div className="toastContainer">
      <div className="Toastify_toast">
        <h1 className="h1Toast">{TOASTER_HEADER}</h1>
        <p className="toaster-survey-description">{WIN_GIFT_CARD} </p>
        <InfoTooltip contentKey={'rewardPayment'} />
        <div className="surveyBtn">
          <a
            href="/survey"
            id="btn"
            onClick={() => {
              mixpanel.track('Survey from Toaster ', {
                path: `${window?.location?.pathname}`,
                clicked: 'survey button',
              });
            }}
          >
            {COMPLETE_SURVEY}
          </a>
        </div>
      </div>
    </div>
  );
}
